import { formatDate, formatDateTime, DATETIME_FORMATS } from '@myap/ui-library/esm/date'
import { fetchStudentChangeLog } from '../../../actions/studentsCommon'
import { Error, SortableTable } from '../../common'
import { usePrevious } from '../../../utils/hooks'
import {
  STUDENT_CHANGELOG_STATUS,
  STUDENT_CHANGE_LOG_TYPE,
  SEE_SUBMISSION_DEADLINE_MSG,
} from '../../../constants/StudentConstants'

const mapStateToProps = (state, { studentId }) => {
  const {
    settingsEducationPeriod: { selectedEducationPeriod: educationPeriodCd },
    user: {
      data: { selectedOrgId: orgId },
    },
    studentChangeLog: { error, data },
    studentsByOrg: {
      studentMap: {
        [studentId]: { firstName, lastName },
      },
      update: { updating: updatingStudent },
    },
  } = state
  return {
    orgId,
    educationPeriodCd,
    studentId,
    error,
    data,
    firstName,
    lastName,
    updatingStudent,
  }
}

const ChangeLogRow = rows => (
  <>
    {rows.map(
      ({
        changeLogId,
        changeLogType,
        changeStatus,
        courseName,
        examDate,
        lastUpdatedByUserFirstName,
        lastUpdatedByUserLastName,
        lastUpdatedByUserName,
        lastUpdatedDate,
        noEndOfCourseExam,
      }) => (
        <tr key={changeLogId}>
          <td className={`logId-${changeLogId}`}>{STUDENT_CHANGE_LOG_TYPE[changeLogType]}</td>
          <td className="log-status" style={{ textTransform: 'capitalize' }}>
            {STUDENT_CHANGELOG_STATUS[changeStatus] || changeStatus.toLowerCase()}
          </td>
          <td className="log-coursename">{courseName || 'N/A'}</td>
          <td className="log-examdate">
            {noEndOfCourseExam
              ? SEE_SUBMISSION_DEADLINE_MSG
              : examDate
              ? formatDate(examDate, DATETIME_FORMATS.mediumMonthDayYear)
              : 'N/A'}
          </td>
          <td className="log-updatedby">
            {lastUpdatedByUserFirstName && lastUpdatedByUserLastName
              ? `${lastUpdatedByUserLastName}, ${lastUpdatedByUserFirstName}`
              : lastUpdatedByUserName}
          </td>
          <td className="log-updatedon">
            {formatDateTime(lastUpdatedDate, 'MM/dd/yyyy HH:mm:ss')}
          </td>
        </tr>
      )
    )}
  </>
)

const StudentChangeLog = ({
  orgId,
  educationPeriodCd,
  studentId,
  error,
  data,
  firstName,
  lastName,
  updatingStudent,
  fetchStudentChangeLog,
}) => {
  const prevUpdatingStudent = usePrevious(updatingStudent)
  const headerColumns = [
    {
      headerText: { title: 'Update Type' },
      key: 'changeLogType',
      sorting: 'asc',
    },
    {
      headerText: { title: 'Value' },
      key: 'changeStatus',
      sorting: 'asc',
    },
    {
      headerText: { title: 'Exam Name' },
      key: 'courseName',
      sorting: 'asc',
    },
    {
      headerText: { title: 'Exam Date' },
      key: 'examDate',
      sorting: 'asc',
    },
    {
      headerText: { title: 'Updated By' },
      key: 'lastUpdatedByUserName',
      sorting: 'asc',
    },
    {
      headerText: { title: 'Updated On' },
      key: 'lastUpdatedDate',
      sorting: 'asc',
      defaultSort: true,
    },
  ]

  useEffect(() => {
    if (orgId && educationPeriodCd) {
      fetchStudentChangeLog(studentId, orgId, educationPeriodCd)
    }
  }, [orgId, educationPeriodCd])

  useEffect(() => {
    if (!updatingStudent && prevUpdatingStudent && orgId && educationPeriodCd) {
      fetchStudentChangeLog(studentId, orgId, educationPeriodCd)
    }
  }, [updatingStudent, prevUpdatingStudent, orgId, educationPeriodCd])

  if (error) return <Error message={error} />

  if (data?.length)
    return (
      <div>
        <h3>Student Change Log</h3>
        <SortableTable
          tableAttributes={{
            id: 'StudentChangeLogTable',
            summary:
              'Change log events are listed by date events were updated on in ascending order. Additional sorting options are available by clicking on the column headers.',
            className: 'table cb-table-striped-reverse',
          }}
          data={data}
          rowBuilder={ChangeLogRow}
          columns={headerColumns}
          tableCaption={{
            caption: `Listing of all change log events for ${firstName} ${lastName}`,
            srOnly: true,
          }}
          tbody={true}
        />
      </div>
    )

  return null
}

export default connect(mapStateToProps, { fetchStudentChangeLog })(StudentChangeLog)
